<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>Tasks Page</h2>

</div>
